import { TPagePropsMetaData } from '@internal/page/TPagePropsMetaData';
import { getPrefetchBlockPropsKey } from '@internal/utils/blocks/getPrefetchBlockPropsKey';
import { TLocale } from '@internal/utils/machine/i18n/TLocale';
import { Block } from 'blocks/Block';
import { TBlockData } from 'blocks/TBlockData';
import { TPreFetchedBlockProps } from 'page/TPreFetchedBlockProps';
import React from 'react';

type Props = {
    blocks: TBlockData[];
    locale: TLocale;
    preFetchedBlockProps: TPreFetchedBlockProps;
    pagePropsMetaData: TPagePropsMetaData;
};

export const Blocks: React.FC<Props> = React.memo(props => (
    <>
        {props.blocks.map((block, index) => (
            <Block
                key={`${block.id}-${block.type}-${index}`}
                rank={index}
                data={block}
                locale={props.locale}
                preFetchedBlockProps={
                    props.preFetchedBlockProps[
                        getPrefetchBlockPropsKey(block)
                    ] ?? {}
                }
                pagePropsMetaData={props.pagePropsMetaData}
            />
        ))}
    </>
));

Blocks.displayName = 'Blocks';
